import React from 'react';

import { useQuery } from '@betterment/js-runtime';
import { Box } from '@betterment/style-closet-react';
import { MarginProps } from 'styled-system';

import PendingSentJointAccountInvitation from './PendingSentJointAccountInvitation';
import SetUpDirectDeposit from './SetUpDirectDeposit';

import { urlBuilder } from '../../../Shared/urlBuilder';
import { AccountTask } from '../../data';
import { useAccount } from '../AccountProvider';

const DEFAULT_COMPONENT_REGISTRY = Object.freeze({
  checking_pending_sent_joint_account_invitation: PendingSentJointAccountInvitation,
  checking_set_up_direct_deposit: SetUpDirectDeposit,
});

type AccountTaskComponent = React.FC<
  React.PropsWithChildren<{
    task: AccountTask;
    refetchTasks: () => void;
  }>
>;

interface Props extends MarginProps {
  componentRegistry?: Record<string, AccountTaskComponent>;
}

const Container: React.FC<React.PropsWithChildren<Props>> = ({
  componentRegistry = DEFAULT_COMPONENT_REGISTRY,
  ...marginProps
}) => {
  const { account } = useAccount();

  const { data: tasks, refetch: refetchTasks } = useQuery<AccountTask<keyof typeof componentRegistry>[]>(
    urlBuilder.getCheckingAccountTasks.absolute({ accountId: account.id }),
    { skip: true }
  );

  React.useEffect(() => {
    void refetchTasks();
  }, [account, refetchTasks]);

  const currentTask = tasks?.find(task => task.name in componentRegistry);
  if (!currentTask) return null;

  const TaskComponent = componentRegistry[currentTask.name];

  return (
    <Box {...marginProps}>
      <TaskComponent task={currentTask} refetchTasks={refetchTasks} />
    </Box>
  );
};

export default Container;
